module.exports = __webpack_public_path__ + "img/About-Nature.ee04d1b4.jpg";